import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Flex, Text, YellowButton } from 'UI';

interface Props {
  onSave: () => void;
  enabled: boolean;
}

const CentralSettingsHeader = ({ onSave, enabled }: Props) => {
  const { t } = useTranslation();
  return (
    <Flex>
      <Flex>
        <Text type="heading3">{t('backoffice.central-settings', 'Settings')}</Text>
      </Flex>
      <Box width={240}>
        <YellowButton onClick={onSave} disabled={!enabled}>
          <Text type={'h4_paragraph'}>{t('common.action.save_modifications', 'Save modifications')}</Text>
        </YellowButton>
      </Box>
    </Flex>
  );
};

export default CentralSettingsHeader;
